'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAME = exports.NAME = 'ldiRenewal';
var validationUrl = exports.validationUrl = process.env.REACT_APP_API_BASE_URI + '/ldi/v1/public/validate-renewal-journey';
var actionTypes = exports.actionTypes = {
  SNAPSHOT: 'ldiRenewal/SNAPSHOT',
  SHOW_SUMMARY: 'ldiRenewal/SHOW_SUMMARY',
  SHOW_FORM: 'ldiRenewal/SHOW_FORM',
  SET_VALIDATED: 'ldiRenewal/SET_VALIDATED',
  SUBMIT_APPLICATION: 'ldiRenewal/SUBMIT_APPLICATION',
  SET_DISCOUNT_CODE: 'ldiRenewal/SET_DISCOUNT_CODE'
};
var stages = exports.stages = [{
  formId: 'renewalStage1',
  requiredStrings: ['claims', 'convictions', 'disallowedOccupations', 'medicalCondition', 'medicalInformed', 'medicalCode', 'modified', 'modifiedForDisability'],
  requiredDates: []
}, {
  formId: 'renewalStage2',
  requiredStrings: ['title', 'forenames', 'surname', 'employmentStatus', 'occupation', 'industry'],
  requiredDates: ['dateOfBirth', 'licenceStartDate']
}, {
  formId: 'renewalStage3',
  requiredStrings: ['email', 'addressLine1', 'addressLine2', 'addressTownCity', 'addressCounty', 'addressPostcode', 'telephone'],
  requiredDates: []
}, {
  formId: 'renewalStage4',
  requiredStrings: ['regNo', 'abiCode', 'value', 'mainInsurer', 'postcodeKeptOvernight', 'keptOvernight', 'owner', 'ownerRelation', 'ownerEmail', 'vehicleOwnerPermission', 'vehicleOwnerPermission', 'thirdPartyPermission', 'thirdPartyName', 'thirdPartyEmail'],
  requiredDates: ['vehiclePurchaseDate']
}, {
  formId: 'renewalStage5',
  requiredStrings: ['cover', 'donation'],
  requiredDates: ['coverStartDate']
}];